var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseRatio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9C13.0875 9 12.75 9.3375 12.75 9.75V11.25H11.25C10.8375 11.25 10.5 11.5875 10.5 12C10.5 12.4125 10.8375 12.75 11.25 12.75H13.5C13.9125 12.75 14.25 12.4125 14.25 12V9.75C14.25 9.3375 13.9125 9 13.5 9ZM5.25 6.75H6.75C7.1625 6.75 7.5 6.4125 7.5 6C7.5 5.5875 7.1625 5.25 6.75 5.25H4.5C4.0875 5.25 3.75 5.5875 3.75 6V8.25C3.75 8.6625 4.0875 9 4.5 9C4.9125 9 5.25 8.6625 5.25 8.25V6.75ZM15.75 2.25H2.25C1.425 2.25 0.75 2.925 0.75 3.75V14.25C0.75 15.075 1.425 15.75 2.25 15.75H15.75C16.575 15.75 17.25 15.075 17.25 14.25V3.75C17.25 2.925 16.575 2.25 15.75 2.25ZM15 14.2575H3C2.5875 14.2575 2.25 13.92 2.25 13.5075V4.4925C2.25 4.08 2.5875 3.7425 3 3.7425H15C15.4125 3.7425 15.75 4.08 15.75 4.4925V13.5075C15.75 13.92 15.4125 14.2575 15 14.2575Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseRatio);
export default __webpack_public_path__ + "static/media/base_ratio.b3bb978eb0882a312172300321e7b9e3.svg";
export { ForwardRef as ReactComponent };